import { Text } from "@acko-tech/building-blocks.ui.typography";
import { styled, Flex } from "@acko-tech/building-blocks.ui.common";

export const Wrapper = styled(Flex)``;

export const MinMaxText = styled(Text)`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #040222;
`;

export const CurrencyText = styled.span`
  color: #36354c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const RiskValue = styled(Text)`
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: #5b5675;
`;

export const SliderValueContainer = styled(Flex)`
  margin-bottom: 3.5rem;
  ${(props) => props.singleRow && `width: fit-content`};
`;

export const StyledFlex = styled(Flex)`
  position: relative;
`;

export const IdvValue = styled(Text)`
  color: #0b753e;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const SliderContainer = styled(Flex)`
  // @media (min-width: 768px) {
  //   padding: ${(props) =>
    props?.isRenewal ? "0px 8px 32px 8px" : "16px 24px 32px 24px"};
  // }
  // @media (min-width: 768px) {
  //   padding: 16px 24px 32px 24px;
  // }
`;

export const IdvNudgeNote = styled(Text)`
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  color: #5b5675;
  text-align: center;
  width: max-content;
  position: absolute;
  right: 50%;
  transform: translateX(50%);
`;

export const IdvRangeContainer = styled.div`
  width: 45%;
  position: absolute;
  top: 16px;
  right: 0px;
  &::after {
    content: "4/5 users select IDV in this range";
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    color: #5b5675;
    text-align: center;
    width: max-content;
    position: absolute;
    right: 50%;
    transform: translateX(50%);
    top: 26px;
  }
`;

export const RecommendedRangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0.5rem;
  right: 0px;
`;

export const RecommendedRangeText = styled.div`
  color: #5b5675;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  line-height: normal;
`;
